import { ICollaboration } from '@descomplica/microfrontend-core';
import { injectable } from 'tsyringe';

import { CertificateEnabledDto } from '@/application/interfaces/classroom/pegasus.gateway';
import { CollaborationResult } from '@/infrastructure/gateways/classroom/models/collaboration-result';
import { PegasusGateway } from '@/infrastructure/gateways/classroom/pegasus.gateway';

import {
  CertificateCourseNotFound,
  CertificateEnabledUnexpectedError,
  ObtainedCertificateEnabled,
} from './get-certificate-enabled.collaboration.responses';

interface Params {
  courseGuid: string;
}

@injectable()
export class GetCertificateEnabledCollaboration
  implements
    ICollaboration<Params, Promise<CollaborationResult<CertificateEnabledDto | undefined>>>
{
  constructor(private pegasusGateway: PegasusGateway) {}

  async run({
    courseGuid,
  }: Params): Promise<CollaborationResult<CertificateEnabledDto | undefined>> {
    try {
      const { data } = await this.pegasusGateway.getCertificateEnabled(courseGuid);

      if (!data) {
        return new CertificateCourseNotFound();
      }
      return new ObtainedCertificateEnabled(data);
    } catch (e) {
      return new CertificateEnabledUnexpectedError();
    }
  }
}
